module.exports = __webpack_public_path__ + "static/media/mds_logo.6e74adb7.png";